import { useTranslation } from "react-i18next";

export function Loading() {
  const { t } = useTranslation();
  return (
    <div className="center-state" role="status">
      {t("common.loading")}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="center-state" role="alert">
      <p>{message}</p>
      {onRetry && (
        <button type="button" className="btn btn-secondary" onClick={onRetry}>
          {t("common.retry")}
        </button>
      )}
    </div>
  );
}

export function Banner({ tone, children }: { tone: "warning" | "info" | "success"; children: React.ReactNode }) {
  return (
    <div className={`banner banner-${tone}`} role={tone === "warning" ? "alert" : "status"}>
      {children}
    </div>
  );
}
